var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 3.75H10.2802C8.87018 3.75 7.53018 4.34 6.58018 5.39L3.05018 9.27C1.64018 10.82 1.64018 13.18 3.05018 14.73L6.58018 18.61C7.53018 19.65 8.87018 20.25 10.2802 20.25H17.0002C19.7602 20.25 22.0002 18.01 22.0002 15.25V8.75C22.0002 5.99 19.7602 3.75 17.0002 3.75ZM16.5302 13.94C16.8202 14.23 16.8202 14.71 16.5302 15C16.3802 15.15 16.1902 15.22 16.0002 15.22C15.8102 15.22 15.6202 15.15 15.4702 15L13.5302 13.06L11.5902 15C11.4402 15.15 11.2502 15.22 11.0602 15.22C10.8702 15.22 10.6802 15.15 10.5302 15C10.2402 14.71 10.2402 14.23 10.5302 13.94L12.4702 12L10.5302 10.06C10.2402 9.77 10.2402 9.29 10.5302 9C10.8202 8.71 11.3002 8.71 11.5902 9L13.5302 10.94L15.4702 9C15.7602 8.71 16.2402 8.71 16.5302 9C16.8202 9.29 16.8202 9.77 16.5302 10.06L14.5902 12L16.5302 13.94Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagCross);
export default __webpack_public_path__ + "static/media/tag-cross.b82fe25de1d79a817195ad48afaf8b04.svg";
export { ForwardRef as ReactComponent };